<div class="navigation-container">
    <mat-accordion class="nav-accordion">
        <ng-container *ngFor="let item of items">
            <mat-expansion-panel *ngIf="item.children?.length; else singleLink">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <mc-icon
                            prefix="far"
                            name="{{ item.icon }}"
                            size="lg"
                            *ngIf="item.icon"
                            [fixedWidth]="true"
                            class="mr-2"
                        >
                        </mc-icon>
                        <div class="left-content pl-4">
                            {{ item.label | translate }}
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <mat-nav-list>
                    <ng-container *ngFor="let child of item.children">
                        <div class="list-item" (click)="changeUrl(child)">
                            <div class="left-content pl-4" [ngClass]="selectedUrl === child.url ? 'selected' : ''">
                                <span>{{ child.label | translate }}</span>
                            </div>
                            <span class="hidden-icon mr-2" (click)="openEditDialog(child)">
                                <i class="fal fa-edit right mr-1"></i>
                                <span class="update-txt">{{ 'app.pagina.editar' | translate }}</span>
                            </span>
                        </div>
                    </ng-container>
                </mat-nav-list>
            </mat-expansion-panel>

            <ng-template #singleLink>
                <div class="menu-single-item-panel">
                    <div class="menu-single-item-panel-header" (click)="changeUrl(item)">
                        <mat-panel-title>
                            <mc-icon
                                prefix="far"
                                name="{{ item.icon }}"
                                size="lg"
                                *ngIf="item.icon"
                                [fixedWidth]="true"
                                class="mr-2"
                            >
                            </mc-icon>
                            <div class="left-content pl-4" [ngClass]="selectedUrl === item.url ? 'selected' : ''">
                                {{ item.label | translate }}
                            </div>
                        </mat-panel-title>
                        <span class="hidden-icon mr-2" (click)="openEditDialog(item)">
                            <i class="fal fa-edit right mr-1"></i>
                            <span class="update-txt">{{ 'app.pagina.editar' | translate }}</span>
                        </span>
                    </div>
                </div>
            </ng-template>
        </ng-container>
    </mat-accordion>
</div>
